'use client'

// Third-party Imports
import { useSession } from 'next-auth/react'

// Util Imports
import { hasPermission } from '@/utils/permissions'

export const usePermissions = () => {
  const { data: session, status } = useSession()

  const permissions = session?.permissions ?? []

  return {
    permissions,
    status,
    canAccess: (permission: string) => hasPermission(permissions, permission)
  }
}
